// extracted by mini-css-extract-plugin
module.exports = {"activatePage":"activatePage___Tsosz","container":"container___-aLtO"};